import { render, staticRenderFns } from "./NewProductDropdown.vue?vue&type=template&id=6e6f0bce&scoped=true&"
import script from "./NewProductDropdown.vue?vue&type=script&lang=js&"
export * from "./NewProductDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NewProductDropdown.vue?vue&type=style&index=0&id=6e6f0bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6f0bce",
  null
  
)

export default component.exports